export default "__VITE_ASSET__CRC5CmPr__"